import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

export const Articles = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const articles = [
    {
      id: 1,
      title: 'Reforma da Previdência: O que mudou para sua aposentadoria',
      category: 'Legislação',
      date: '15 de Março, 2024',
      readTime: '5 min',
      excerpt:
        'Entenda as principais mudanças trazidas pela reforma da previdência e como elas impactam no seu planejamento de aposentadoria.',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=800',
    },
    {
      id: 2,
      title: 'Como calcular o tempo de contribuição corretamente',
      category: 'Tutoriais',
      date: '10 de Março, 2024',
      readTime: '7 min',
      excerpt:
        'Aprenda a calcular seu tempo de contribuição de forma correta e evite surpresas na hora de solicitar sua aposentadoria.',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=800',
    },
    {
      id: 3,
      title: 'Aposentadoria Especial: Quem tem direito?',
      category: 'Benefícios',
      date: '5 de Março, 2024',
      readTime: '6 min',
      excerpt:
        'Descubra se você tem direito à aposentadoria especial e quais são os requisitos necessários para obtê-la.',
      image: 'https://images.unsplash.com/photo-1568992687947-868a62a9f521?q=80&w=800',
    },
    {
      id: 4,
      title: 'Revisão da Vida Toda: Vale a pena solicitar?',
      category: 'Revisões',
      date: '28 de Fevereiro, 2024',
      readTime: '8 min',
      excerpt:
        'Entenda o que é a revisão da vida toda e descubra se ela pode aumentar o valor do seu benefício previdenciário.',
      image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?q=80&w=800',
    },
    {
      id: 5,
      title: 'BPC/LOAS: Guia completo para solicitar o benefício',
      category: 'Benefícios',
      date: '22 de Fevereiro, 2024',
      readTime: '10 min',
      excerpt:
        'Tudo o que você precisa saber sobre o Benefício de Prestação Continuada: requisitos, documentação e como solicitar.',
      image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=800',
    },
    {
      id: 6,
      title: 'Planejamento Previdenciário: Por que é importante?',
      category: 'Planejamento',
      date: '15 de Fevereiro, 2024',
      readTime: '6 min',
      excerpt:
        'Descubra a importância do planejamento previdenciário e como ele pode garantir uma aposentadoria mais vantajosa.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=800',
    },
  ];

  const categories = ['Todos', 'Legislação', 'Tutoriais', 'Benefícios', 'Revisões', 'Planejamento'];
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  const filteredArticles = articles.filter((article) => {
    const matchesSearch =
      article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === 'Todos' || article.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative min-h-[400px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage:
            'linear-gradient(135deg, rgba(45, 66, 56, 0.9) 0%, rgba(45, 66, 56, 0.8) 100%), url(https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?q=80&w=2076)',
        }}
      >
        <div className="container-padding mx-auto text-center relative z-10">
          <div className="max-w-3xl mx-auto space-y-4 slide-up">
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-primary-foreground">
              Artigos e Notícias
            </h1>
            <p className="text-lg sm:text-xl text-primary-foreground/90">
              Fique por dentro das últimas novidades sobre direito previdenciário
            </p>
          </div>
        </div>
      </section>

      {/* Search and Filter */}
      <section className="section-padding bg-background">
        <div className="container-padding mx-auto">
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto mb-8 slide-up">
            <div className="relative">
              <i className="fas fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground"></i>
              <Input
                type="text"
                placeholder="Buscar artigos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-12 py-6 text-lg border-border"
              />
            </div>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12 slide-up">
            {categories.map((category) => (
              <Button
                key={category}
                variant={selectedCategory === category ? 'default' : 'outline'}
                onClick={() => setSelectedCategory(category)}
                className={
                  selectedCategory === category
                    ? 'bg-accent hover:bg-accent-hover text-accent-foreground'
                    : 'border-border text-foreground hover:bg-secondary'
                }
              >
                {category}
              </Button>
            ))}
          </div>

          {/* Articles Grid */}
          {filteredArticles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {filteredArticles.map((article, index) => (
                <Card
                  key={article.id}
                  className="card-hover border-border overflow-hidden cursor-pointer group"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-accent text-accent-foreground text-xs font-semibold px-3 py-1 rounded-full">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <CardContent className="p-6 space-y-3">
                    <div className="flex items-center text-sm text-muted-foreground space-x-4">
                      <span className="flex items-center">
                        <i className="far fa-calendar mr-2"></i>
                        {article.date}
                      </span>
                      <span className="flex items-center">
                        <i className="far fa-clock mr-2"></i>
                        {article.readTime}
                      </span>
                    </div>
                    <h3 className="font-display text-xl font-semibold text-foreground group-hover:text-accent transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed line-clamp-3">
                      {article.excerpt}
                    </p>
                    <div className="pt-2">
                      <span className="text-accent hover:text-accent-hover font-semibold text-sm inline-flex items-center group">
                        Ler mais
                        <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                      </span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <i className="fas fa-search text-muted-foreground text-5xl mb-4"></i>
              <h3 className="font-display text-2xl font-semibold text-foreground mb-2">
                Nenhum artigo encontrado
              </h3>
              <p className="text-muted-foreground">
                Tente buscar por outros termos ou selecione outra categoria
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="section-padding bg-gradient-to-r from-primary to-primary-dark text-primary-foreground">
        <div className="container-padding mx-auto">
          <div className="max-w-3xl mx-auto text-center space-y-6 slide-up">
            <i className="fas fa-envelope text-accent text-5xl mb-4"></i>
            <h2 className="font-display text-3xl sm:text-4xl font-bold">
              Receba Notícias em Seu E-mail
            </h2>
            <p className="text-lg text-primary-foreground/90">
              Cadastre-se para receber atualizações sobre direito previdenciário diretamente em
              sua caixa de entrada.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto pt-4">
              <Input
                type="email"
                placeholder="Seu melhor e-mail"
                className="flex-1 py-6 bg-primary-foreground/10 border-primary-foreground/20 text-primary-foreground placeholder:text-primary-foreground/60"
              />
              <Button
                size="lg"
                className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-8 shadow-xl"
              >
                Inscrever-se
              </Button>
            </div>
            <p className="text-sm text-primary-foreground/60">
              Nós respeitamos sua privacidade. Seus dados estão seguros.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Articles;